/**
 * Returns the user's full name, or the first non-blank fallback (typically e-post or brukerId)
 * when the name is missing or only whitespace. Returns an empty string if everything is blank.
 */
export const getBrukerDisplayName = (
    fulltnavn: string | null | undefined,
    ...fallbacks: Array<string | null | undefined>
): string => {
    for (const value of [fulltnavn, ...fallbacks]) {
        const trimmed = value?.trim();
        if (trimmed) return trimmed;
    }
    return '';
};
